import { AuthorizedUser } from "../api/repositories/backend/models/auth";
import { TableHeaderColSort } from "../client/components/ui/models/tables";
import { localize } from "./services/localization";

export function isNothing(value?: any): boolean {
    return value === null || value === undefined;
}

export function combineAddress(url: string, path: string): string {
    return `${url.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export function getShortString(text: string, length: number = 10) {
    return text.length > length ? text.slice(0, length) + "..." : text;
}

export function getHero(name: string, heroes: Hero[]): Hero | undefined {
    return heroes.find(f => f.name === name);
}

export function getHeroFriendlyName(name: string, heroes: Hero[]): string | undefined {
    return heroes.find(f => f.name === name)?.userFriendlyName;
}

function parseUTCDate(value: string): Date {
    return new Date(value.endsWith('Z') ? value : value + 'Z');
}

export function toDateWithTime(value: string): string {
    const date = parseUTCDate(value);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).toString().slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export function toDate(value: string): string {
    const date = parseUTCDate(value);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).toString().slice(-2);

    return `${day}.${month}.${year}`;
}

export function toDateString(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).toString().slice(-2);

    return `${day}.${month}.${year}`;
}

export function clearSteamLink(value?: string): string | undefined {
    return value?.replace('?xml=1', '');
}

export function isSubActive(user?: AuthorizedUser): boolean {
    return !!(user && user.dotaPlusExpireDate && user.dotaPlusExpireDate > Date.now());
}

export function sortByCondition(a: any, b: any, sortCondition?: TableHeaderColSort): number {
    if (!sortCondition)
        return 0;

    const { key, direction } = sortCondition;
    const dir = direction === 'asc' ? 1 : -1;

    if (a[key] == null)
        return 1;
    if (b[key] == null)
        return -1;

    if (a[key] > b[key])
        return dir;
    if (a[key] < b[key])
        return -dir;

    return 0;
}

export function getDotaTextWithReplaces(content?: string): string {
    return content?.replace('#53ea48', '#00C950').replace('#ff0000', '#FF3A43') ?? '';
}

export function toLowerWith(content?: string): string {
    return content?.replace('#53ea48', '#00C950').replace('#ff0000', '#FF3A43') ?? '';
}

export function getValueOrDefault(value?: any) {
    return isNothing(value) ? '—' : value;
}

export function getMinutesOrDefault(value?: number | undefined) {
    return getValueOrDefault(value && `${Math.floor(value / 60)} ${localize('minutes')}`)
}

export function getColorByPlace(place?: number) {
    return place
        ? place <= 3 ? 'text-green' : 'text-red'
        : ''
}

export function getRatingChange(ratingChange?: number, isDouble?: boolean) {
    const isDoublePart = isDouble ? ' (x2)' : ''

    if (ratingChange) {
        if (ratingChange > 0) {
            return `+${ratingChange}${isDoublePart}`
        }
        else {
            return `${ratingChange}${isDoublePart}`
        }
    }
}